import React, { useContext } from "react";
import { RESOURCE_NAME } from "common/authorization";
import { WorkflowStepManualStatus } from "../../generated/graphql";
import { AuthContext } from "../Authorization/AuthContext";
import { Actions } from "../Common/ActionCell";
import { ActionsProps } from "../Inputs/DropdownMenu";
import { useUpdateWorkflowStepStatusModal } from "./useUpdateWorkflowStepStatusModal";

interface WorkflowStepActionsProps {
  workflowStepId: string;
  workflowStepManualStatus: WorkflowStepManualStatus;
  submissionTypeName: string;
  canShare: boolean;
}

export const WorkflowStepActions = ({
  workflowStepId,
  workflowStepManualStatus,
  submissionTypeName,
  canShare,
}: WorkflowStepActionsProps) => {
  const { authorized } = useContext(AuthContext);
  const [showUpdateStatusModal] = useUpdateWorkflowStepStatusModal({
    workflowStepId,
    workflowStepManualStatus,
    submissionTypeName,
    onUpdate: () => {
      // Refresh handled by refetchQueries in mutation
    },
  });

  const canShareWorkflow =
    canShare &&
    authorized({ permission: "share", resource: RESOURCE_NAME.WORKFLOW });

  const actions: ActionsProps[] = [
    {
      label: "Update status",
      onClick: showUpdateStatusModal,
    },
    ...(canShareWorkflow ?
      [
        {
          label: "Add collaborator",
          onClick: () => {},
        },
      ]
    : []),
  ];

  return <Actions actions={actions} />;
};
